function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M412.532,414.528c-3.009-4.629-9.203-5.946-13.835-2.935l-0.235,0.152c-4.63,3.01-5.945,9.204-2.935,13.835 c1.916,2.947,5.123,4.551,8.395,4.551c1.867,0,3.758-0.523,5.44-1.616l0.235-0.152 C414.227,425.353,415.542,419.159,412.532,414.528z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M351.904,67.922c-0.356-0.089-0.714-0.175-1.07-0.258c-5.379-1.258-10.757,2.084-12.013,7.462 c-1.257,5.378,2.084,10.757,7.462,12.013c0.271,0.063,0.542,0.128,0.813,0.195c0.808,0.2,1.616,0.296,2.412,0.296 c4.489,0,8.571-3.045,9.699-7.598C360.534,74.672,357.264,69.25,351.904,67.922z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M423,41.726c-27.57,0-50,22.43-50,50s22.43,50,50,50s50-22.43,50-50S450.57,41.726,423,41.726z M423,121.726 c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S439.542,121.726,423,121.726z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M512,249.226c0-36.484-29.683-66.167-66.167-66.167c-13.682,0-26.907,4.233-37.988,12.018 c-36.751-23.282-82.841-37.263-132.168-40.207l9.053-29.071c4.563-14.655,14.58-26.626,28.206-33.71 c4.9-2.547,6.808-8.584,4.261-13.485c-2.547-4.9-8.584-6.808-13.485-4.26c-18.395,9.562-31.917,25.724-38.077,45.509 l-10.722,34.43c-56.276,0.184-109.424,14.609-150.757,40.794c-11.081-7.785-24.307-12.018-37.988-12.018 C29.683,183.059,0,212.741,0,249.226c0,22.729,11.432,43.444,30.252,55.571C30.09,307.279,30,309.771,30,312.274 c0,42.931,24.012,83.026,67.612,112.9c42.445,29.083,98.694,45.1,158.388,45.1c42.418,0,83.739-8.212,119.497-23.747 c5.064-2.201,7.387-8.092,5.187-13.157c-2.201-5.065-8.093-7.388-13.157-5.187c-33.263,14.452-71.827,22.091-111.526,22.091 c-55.698,0-107.934-14.773-147.083-41.598C70.924,382.643,50,348.408,50,312.274c0-36.134,20.924-70.371,58.917-96.403 c39.149-26.825,91.385-41.598,147.083-41.598s107.934,14.773,147.083,41.598C441.076,241.904,462,276.14,462,312.274 c0,26.926-11.722,53.072-33.896,75.611c-3.874,3.938-3.822,10.269,0.114,14.142c3.939,3.876,10.27,3.821,14.142-0.114 c25.933-26.359,39.64-57.356,39.64-89.639c0-2.503-0.09-4.995-0.252-7.478C500.568,292.67,512,271.955,512,249.226z  M33.996,282.356C25.155,273.806,20,261.969,20,249.226c0-25.457,20.71-46.167,46.167-46.167c7.047,0,13.924,1.605,20.152,4.63 C59.367,228.999,41.484,254.639,33.996,282.356z M478.004,282.357c-7.488-27.717-25.372-53.358-52.323-74.667 c6.229-3.026,13.105-4.63,20.152-4.63c25.457,0,46.167,20.71,46.167,46.167C492,261.969,486.845,273.806,478.004,282.357z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M330.968,242.892c-23.159,0-42,18.841-42,42s18.841,42,42,42s42-18.841,42-42S354.127,242.892,330.968,242.892z  M330.968,306.892c-12.131,0-22-9.869-22-22c0-12.131,9.869-22,22-22c12.131,0,22,9.869,22,22 C352.968,297.023,343.099,306.892,330.968,306.892z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M183.776,242.892c-23.159,0-42,18.841-42,42s18.841,42,42,42c23.16,0,42-18.841,42-42S206.935,242.892,183.776,242.892z  M183.776,306.892c-12.131,0-22-9.869-22-22c0-12.131,9.869-22,22-22s22,9.869,22,22 C205.776,297.023,195.907,306.892,183.776,306.892z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M341.355,367.487c-3.254-4.468-9.509-5.445-13.971-2.197c-42.572,31.005-99.835,31.085-142.495,0.198 c-4.473-3.239-10.726-2.24-13.964,2.235c-3.24,4.474-2.239,10.726,2.235,13.964c24.192,17.517,52.829,26.77,82.835,26.77 c0.063,0,0.13,0,0.193,0c30.08-0.039,58.771-9.376,82.97-26.999C343.623,378.206,344.606,371.951,341.355,367.487z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.582de513.svg";
export { ForwardRef as ReactComponent };